<template>
  <b-modal size="lg"
           :no-close-on-esc="true"
           :no-close-on-backdrop="true"
           :hide-header-close="true"
           v-model="showModal">
    <div slot="modal-title">
      PDPA Consent
    </div>
    <div v-if="pdpaConsent">
      <div class="row">
        <div class="col-12">
          <h3 class="text-center">{{ pdpaConsent.name }}</h3>
          <div class="py-4">
            {{ pdpaConsent.detail }}
          </div>
          <div class="px-4" v-if="pdpaConsent">
            <div class="d-flex pb-3" v-for="option in pdpaConsent.options">
              <div>
                <input class="form-check-input" type="checkbox" :id="option.id" :value="option"
                       v-model="selectedOptions"/>
              </div>
              <div class="pl-2">
                <label class="form-check-label" :for="option.id">
                  {{ option.name }}
                  <span class="text-danger" v-if="option.required">*</span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div slot="modal-footer" class="w-100 text-right">
      <button class="btn btn-info btn-lg"
              :disabled="isLoading"
              @click="saveUserPdpaConsent()">
        {{ isLoading ? 'กำลังโหลด...' : 'บันทึก' }}
      </button>
    </div>
  </b-modal>
</template>

<script>
  import axios from 'axios'

  export default {
    data () {
      return {
        professionalRegisterId: null,
        isLoading: false,
        pdpaConsent: null,
        selectedOptions: [],
        errorCode: null,
        showModal: false
      }
    },
    methods: {
      async fetchPdpaConsent (professionalRegisterId) {
        this.professionalRegisterId = professionalRegisterId
        const url = '/pdpa-consents'
        const params = {
          professional_register_id: this.professionalRegisterId,
          user_type: 'professional_register'
        }
        const { data } = await axios.get(url, { params })
        if (!data.error) {
          if (!data.user_pdpa_consent) {
            this.pdpaConsent = data.pdpa_consent
            this.showModal = true
          }
        }
      },
      isFormValidation () {
        const requiredOptions = this.pdpaConsent.options.filter(option => option.required === 1)
        const requiredOptionIds = requiredOptions.map(option => option.id)
        const selectedOptionIds = this.selectedOptions.map(option => option.id)
        let count = 0
        for (const id of requiredOptionIds) {
          if (selectedOptionIds.includes(id)) {
            count += 1
          }
        }
        return (count === requiredOptions.length)
      },
      async saveUserPdpaConsent () {
        if (this.isFormValidation()) {
          this.isLoading = true
          const url = '/user-pdpa-consents'
          const submitData = {
            pdpa_consent_id: this.pdpaConsent.id,
            professional_register_id: this.professionalRegisterId,
            options: this.selectedOptions
          }
          const { data } = await axios.post(url, submitData)
          this.isLoading = false
          if (!data.error) {
            // Close PDPA Consent modal
            this.showModal = false
            this.$swal({text: 'บันทึกข้อมูลสำเร็จ', type: 'success'})
          } else {
            this.$swal({text: data.message, type: 'error'})
          }
        } else {
          this.$swal({text: 'คุณจำเป็นต้องเลือกข้อที่กำหนด', type: 'error'})
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/professional/PdpaConsentModal.vue